<template>
  <div
    class="report__header-container d-flex align-items-center justify-content-center"
    :style="dynamicHeaderStyles"
  >
    <img
      v-if="hasLogo"
      :src="officeLogoUrl"
      class="report__header-logo"
      crossorigin="*"
    />
    <div v-else class="report__header-logo"></div>
  </div>
</template>

<script>
import {CARD_GAP, REPORT_BORDER_RADIUS} from '../constants';
export default {
  props: {
    officeLogoUrl: String,
  },
  inject: ['getBrandPrimaryBackground'],
  data() {
    const bg = this.getBrandPrimaryBackground();
    return {
      dynamicHeaderStyles: {
        backgroundColor: bg || '#4f4f4f',
        borderRadius: REPORT_BORDER_RADIUS,
        marginBottom: CARD_GAP,
      },
    };
  },
  computed: {
    hasLogo() {
      return this.officeLogoUrl ? true : false;
    },
  },
};
</script>

<style>
.report__header-container {
  padding: 16px;
}

.report__header-logo {
  height: 24px;
}
</style>
